import { Row, Col, Form, Button, Modal, Table } from 'react-bootstrap';
import { useState } from 'react';
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrashCan  } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";



const NewModelModal = ({ show, requestClose, selectedClientID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    const servicesURL = process.env.REACT_APP_SERVICES_API_URL;
    const backendAPI_Key = process.env.REACT_APP_API_KEY;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    //SELECTED ID COMES FROM SHORTCUT NEW ORDER MODAL
    const clientID = selectedClientID  ? selectedClientID : queryParams.get("clientID");

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [model, setModel] = useState(null);

    
    const [modelListing, setModelListing] = useState([]);


    const getModelsByCustomer = async () => {


        const endpoint = "getModels?clienteId=" + clientID;
        
        const response = await fetch(servicesURL + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key}
        });

        const responseContent = await response.json();

        setModelListing(responseContent);

       


    } //END FUNCTION

    const addNewModel = async () => {

        //
        //MAIN VALIDATION
        //

        if(!model){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe indicar el modelo.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }

        

        //REQUEST
        const endpoint = "addModel?clienteId=" + clientID + "&modelo=" + model;

        await fetch(servicesURL + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
            body: ""

        }).then(responseContent => {

            if(responseContent.status == 400){

                Swal.fire({
                    title: "Error!",
                    text: "Este modelo ya existe.",
                    icon: "error",
                    confirmButtonText: "OK"
                });

            } else if(responseContent.status == 500){

                //Show message sweet alert
                Swal.fire({
                    title: "Error!",
                    text: responseContent.statusText,
                    icon: "error",
                    confirmButtonText: "OK"
                });


            } else if(responseContent.status == 200){

                //Show message sweet alert
                Swal.fire({
                    title: "¡Éxito!",
                    text: "Operación realizada exitosamente.",
                    icon: "success",
                    confirmButtonText: "OK"
                });

                //CLOSE MODAL
                requestClose(false);

            }
        });


    } //
    

    const deleteModel = async (model) => {

        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esta acción borrará el modelo y todos los seriales asociados.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'

        }).then((result) => {


            if (result.isConfirmed) {

                //REQUEST
                const endpoint = "eliminarModelo?clienteId=" + clientID + "&modelo=" + model;

                fetch(servicesURL + endpoint,
                {
                    method: "POST",
                    headers: {"Content-Type": "application/json", "X-API-KEY" : backendAPI_Key},
                    body: ""

                }).then(responseContent => {

                    //Show message sweet alert
                    Swal.fire({
                        title: "¡Éxito!",
                        text: "Operación realizada exitosamente.",
                        icon: "success",
                        confirmButtonText: "OK"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }});
                });

            }//END IF
        }) //END THEN

    } //END FUNCION

    const onModalShow = () => {

        //GET MODELS
        getModelsByCustomer(); 

        
    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Agregar / Eliminar Modelo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Agregar Modelo</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Nuevo Modelo" 
                             onChange={(event)=> setModel(event.target.value)} /><br />
                        </Form.Group>

                        <Button 
                            style={{float:"right"}}
                            variant="success" 
                            size='sm'
                            onClick={addNewModel}>
                            Agregar Modelo
                        </Button>

                    </Col>
                </Row>
               <hr />
                <Row style={{marginTop:"50px"}}>
                    <Col xs={12}>

                        <div style={{fontSize:"14px", color:"#000066", textAlign:"left", fontWeight:"bold"}}>Modelos Registrados <br /></div>

                         <hr />

                        <Table striped className="mainTable">
                        <thead>
                            <tr>
                                <th>Modelo</th>
                                <th style={{textAlign:"center"}}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>

                            {modelListing.length > 0 && modelListing.map((item)=>{

                                return (
                                    
                                    <tr key={item}>
                                        <td>{item}</td>
                                        <td style={{textAlign:"center"}}>
                                            <FontAwesomeIcon icon={faTrashCan} 
                                            style={{paddingLeft:"0px", color: "red", cursor:"pointer"}} title='Eliminar Modelo' onClick={()=> {deleteModel(item); }} />
                                        </td>
                                    </tr>

                                )
                            })}

                        </tbody>
                        </Table>
                    
                    </Col>

                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>

            </Modal.Footer>
        </Modal>
        </>
    );
}

export default NewModelModal;